<template>
  <div class="table-responsive">
    <dynamic-table :columns="opinionsAssignedReviewersColumns"
                   :data="assignedReviewerDictums"
                   :loading="loading"
                   class="table-hover"
                   empty-message="No se han emitido dictámenes por parte de los revisores.">
  
      <template v-slot:dictum_type_title="slotProps">
        <span v-if="slotProps.row.dictum_type_title === 'Aprobado'"
            class="badge badge-success">{{ slotProps.row.dictum_type_title }}</span>
        <span
            v-else-if="slotProps.row.dictum_type_title === 'No aprobado' || slotProps.row.dictum_type_title === 'Rechazado'"
            class="badge badge-subtle badge-danger">{{ slotProps.row.dictum_type_title }}</span>
        <span v-else
            class="badge badge-subtle badge-dark">{{ slotProps.row.dictum_type_title ? slotProps.row.dictum_type_title : 'Sin dictamen' }}</span>
      </template>

      <template v-slot:reviewer_dictum_send_dictum="slotProps">
        <p v-if="slotProps.row.reviewer_dictum_send_dictum === 1">
          Pueden enviarse los comentarios y dictamen al responsable de proyecto.
        </p>
        <p v-else-if="slotProps.row.reviewer_dictum_send_dictum === 0">
          El proyecto deberá presentarse en la siguiente sesión.
        </p>
        <span v-else
            class="badge badge-subtle badge-dark">
          Sin dictamen
        </span>
      </template>

      <template v-slot:researcher_status="slotProps">
        <span :class="showReviewerStatus(slotProps.row.researcher_status_key).class"
              class="badge">{{ showReviewerStatus(slotProps.row.researcher_status_key).title }}</span>
      </template>

      <template v-slot:reviewer_dictum_revision="slotProps">
        <template v-if="slotProps.row.reviewer_dictum_revision">
          {{ slotProps.row.reviewer_dictum_revision }}
        </template>
        <span v-else
              class="badge badge-subtle badge-dark">
          Sin dictamen
        </span>
      </template>
      
      <template v-slot:actions="slotProps">
        <div class="list-group-item-figure align-items-start justify-content-center">
          <div class="dropdown">
            <button aria-expanded="false" class="btn btn-sm btn-icon btn-light"
                    data-toggle="dropdown">
              <i class="fa fa-fw fa-ellipsis-v"></i>
            </button>
            <div class="dropdown-menu dropdown-menu-right" style="">
              <div class="dropdown-arrow mr-n1"></div>
              <button class="dropdown-item"
                      type="button"
                      @click="showComments(slotProps.row.reviewer_dictum_comments)"
                      :disabled="!slotProps.row.reviewer_dictum_comments || slotProps.row.reviewer_dictum_comments === ''">
                Ver comentarios del revisor
              </button>
            </div>
          </div>
        </div>
      </template>
    </dynamic-table>
  
    <portal to="reviewers-modal">
      <ok-cancel-dialog :id="`show-reviewers-dictums-modal-${uuid}`"
                        ref="show-reviewers-dictums-modal"
                        title="Comentarios"
                        :show-ok-button="false"
                        cancel-button-text="Aceptar"
                        backdrop="normal"
                        :keyboard="'true'"
                        scrollable
                        large
                        :content="comments"></ok-cancel-dialog>
    </portal>
  </div>
</template>

<script>
  import DynamicTable from '../../ui/DynamicTable'
  import OkCancelDialog from '../../ui/OkCancelDialog'
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'AssignedReviewersDictums',
    components: {
      DynamicTable,
      OkCancelDialog,
    },
    props: {
      protocol: Object,
      committee: Object,
    },
    data() {
      return {
        comments: '',
        loading: true,
        uuid: Math.guid(),
        opinionsAssignedReviewersColumns: [
          {
            field: 'user_full_name',
            title: 'Nombre',
            tdClass: 'align-middle',
            tdStyle: {},
            thClass: 'align-middle',
            thStyle: {},
          },
          {
            field: 'committee_name',
            title: 'Comite',
            tdClass: 'align-middle',
            tdStyle: {},
            thClass: 'align-middle',
            thStyle: {},
          },
          {
            field: 'protocol_reviews_created_at',
            title: 'Fecha de asignación',
            tdClass: 'align-middle',
            tdStyle: {},
            thClass: 'align-middle',
            thStyle: {},
          },
          {
            field: 'dictum_type_title',
            title: 'Dictamen',
            tdClass: 'align-middle',
            tdStyle: {},
            thClass: 'align-middle',
            thStyle: {},
          },
          {
            field: 'reviewer_dictum_created_at',
            title: 'Fecha de dictamen',
            tdClass: 'align-middle',
            tdStyle: {},
            thClass: 'align-middle',
            thStyle: {},
          },
          {
            field: 'reviewer_dictum_send_dictum',
            title: 'Dictamen y comentarios',
            tdClass: 'align-middle',
            tdStyle: {},
            thClass: 'align-middle',
            thStyle: {},
          },
          {
            field: 'researcher_status',
            title: 'Respuesta',
            tdClass: 'align-middle',
            tdStyle: {},
            thClass: 'align-middle',
            thStyle: {},
          },
          {
            field: 'reviewer_dictum_revision',
            title: 'Revisión',
            tdClass: 'align-middle text-center',
            tdStyle: {},
            thClass: 'align-middle',
            thStyle: {},
          },
          {
            field: 'actions',
            title: 'Acciones',
            tdClass: 'align-middle text-center',
            tdStyle: {},
            thClass: 'align-middle text-center',
            thStyle: {},
          },
        ],
      }
    },
    methods: {
      ...mapActions({
        getAssignedReviewerDictums: 'committees/getAssignedReviewerDictums',
      }),
      
      async load() {
        this.loading = true
        
        const { protocol, committee } = this
        
        await this.getAssignedReviewerDictums({
          protocol,
          committee,
        })
        
        this.loading = false
      },
  
      showComments (comments) {
        this.comments = comments
  
        $(`#show-reviewers-dictums-modal-${this.uuid}`).modal('show')
      },
  
      showReviewerStatus (key) {
        const titleStatuses = {
          enviado: {
            title: 'Pendiente por investigador',
            class: 'badge-primary',
          },
          aceptado: {
            title: 'Investigador aceptó invitación',
            class: 'badge-success',
          },
          rechazado: {
            title: 'Investigador rechazó invitación',
            class: 'badge-warning',
          },
          cancelado: {
            title: 'El comité canceló la invitación',
            class: 'badge-subtle badge-danger',
          },
          default: {
            title: 'El comité canceló la invitación',
            class: 'badge-subtle badge-dark',
          },
        }
    
        if (key in titleStatuses) {
          return titleStatuses[key]
        }
    
        return titleStatuses.default
      },
    },
    computed: {
      ...mapGetters({
        assignedReviewerDictums: 'committees/assignedReviewerDictums',
      }),
    },
    async mounted() {
      await this.load()
    },
  }
</script>
